export function getPrimaryCount(tx) {
  return tx.filter(t => t.primary_payer).length
}
